export function authHeader() {
    let userStr = localStorage.getItem('user')
    if (!userStr) {
        return {};
    }
    // return authorization header with basic auth credentials
    let user = JSON.parse(userStr);

    if (user && user.access_token) {
        return { 'Authorization': 'Bearer ' + user.access_token };
    } else {
        return {};
    }
}
